<template>
    <div class="photo-upload-list">
        <!-- 表格 -->
         <h1>资源上传列表</h1>
        <el-table
          height="400"
          class="table"
          ref="multipleTable"
          :data="uploaders"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#f2f2f2'}"
          >
          <el-table-column label="资源" align="center">
              <template slot-scope="scope">
                  <!-- //base64 -->
                   <div style="display: flex;align-items: center;">
                    <img v-if="!scope.row.isVideo" style="width: 60px;height: 60px; object-fit: contain;" :src="scope.row.thumbase64" alt="">
                    <video v-else :src="`${baseURL}/${scope.row.file_path}`" style="width: 60px;height: 60px; object-fit: contain;"></video>
                    <span>{{scope.row.file_nickname}}</span>
                   </div>
                 
              </template>
          </el-table-column>
          <el-table-column label="尺寸" align="center" prop="size"></el-table-column>
          <el-table-column label="大小" align="center" prop="origionsize_string"></el-table-column>
          <el-table-column label="进度" align="center">
              <template slot-scope="scope">
              <!-- 进度条/fail/success -->
               <div v-if="scope.row.status==0">
                准备中
               </div>
               <div v-else-if="scope.row.status==1">
                上传中
               </div>
               <div v-else-if="scope.row.status==2">
                上传成功
               </div>
               <div v-else-if="scope.row.status==3">
                上传失败
               </div>
              </template>
          </el-table-column>
        </el-table>
    </div>
  </template>
  
  <script>
import { event_msg_keys } from '../../eventbus/eventkeys';
import { Status } from '../../uploader/upload';
import { baseURL } from '../../api/api';

    export default {
      name: 'photos-upload-list',
      props: {
        value: {
          type: Boolean,
          default: false,
        },
        uploaders:{
            type:Array,
            default:[]
        }
      },
      data() {
        return {
          baseURL,
          Status
        };
      },
      mounted(){
        this.$evt.on(event_msg_keys.image_upload_success,this.image_upload_status_callback)
        this.$evt.on(event_msg_keys.image_upload_fail,this.image_upload_status_callback)
      },
      destroyed(){
        this.$evt.off(event_msg_keys.image_upload_success,this.image_upload_status_callback)
        this.$evt.off(event_msg_keys.image_upload_fail,this.image_upload_status_callback)
      },
      computed: {
        
      },
      methods: {
        video_url(path){
          return `${baseURL}/${path}`
        },
        image_upload_status_callback(){
          console.log('image_upload_status_callback',this.uploaders)
          this.$forceUpdate()
        }
      }
    };
  </script>
  
<style lang="less">
.photo-upload-list{
    margin-top: 20px;
   
   
   .table{
    border: solid 1px lightgray;
   }
}

</style>
  